import api from "./index";

import cookiesHelper from "../helpers/cookies";

import { ISaveOrganization } from "../interfaces/services";
import { IOrganizationForTree } from "../interfaces/tree";

export const getOrganizations = async (): Promise<IOrganizationForTree[]> => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`organizations/tree`);
        return res.data?.data?.length ? res.data.data : [];
    } catch (error: any) {
        throw error?.response?.data;
    };
};

export const saveOrganization = async (data: ISaveOrganization) => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`

    try {
        const res = await api.post(`organizations`, data);
        return res.data;
    } catch (error: any) {
        throw error?.response?.data;
    };
};